import { BreadcrumbTrail, PageHeader } from '@/components/ui'
import { BankruptcyStatusBadge } from '@/modules/tools/bankruptcy/components/BankruptcyStatusBadge'
import type { Filing } from '@/modules/tools/bankruptcy/stores/types'

export const CaseHeader = ({ filing }: { filing: Filing }) => (
  <div className="space-y-6">
    <BreadcrumbTrail
      crumbs={[
        { label: 'Bankruptcy Screener', to: '/tools/bankruptcy-screener' },
      ]}
      page={filing.name}
    />

    <PageHeader
      title={filing.name}
      subtitle={filing.caseNumber ?? 'No case number yet'}
    >
      <BankruptcyStatusBadge status={filing.status} />
    </PageHeader>
  </div>
)
